import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContextHolder } from "@frontegg/react";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const baseUrl = ContextHolder.getContext().baseUrl;
    window.location.replace(
      `${baseUrl}/oauth/logout?post_logout_redirect_uri=${process.env.REACT_APP_URL}`,
    );
    localStorage.removeItem("isSetup");
  }, [navigate]);

  return null;
}
